import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService, MenuItem } from 'primeng/api';
import { MerchantService, StoreService, AppDataService, ProductService } from 'app/services';
import { LocationType, UOMCategory } from 'app/models';
import { MerchantStoreOnboardingComponent, MerchantProductsComponent } from 'app/merchant';
import { PartnerMartLocationsInventoryGridComponent } from 'app/partner';

enum MenuTab {
    ProductDetails = 1,
    Pricing = 2,
    UOM = 3,
    ProductAvailability = 4,
    Inventory = 5
}

enum InfoForFields {
    DailyInventory = 1,
    SendLowInventoryEmail = 2,
    Supplier = 3
}

@Component({
    selector: 'merchant-edit-product',
    templateUrl: './merchant-edit-product.component.html',
    styleUrls: ['./merchant-edit-product.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'],
    providers: [MessageService]
})
export class MerchantEditProductComponent implements OnInit {
    public productId: number = 0;
    @Input()
    set _productId(value: number) {
        this.productId = value;
        if (this.productId > 0) {
            this.loading = true;
            this.getAllCategories().then(
                category => {
                    if (category === 'Success') {
                        this.getProductForEdit().catch(error => {
                            console.log('Product: ' + error);
                        });
                    }
                }
            ).catch(error => {
                console.log('Category:' + error);
            });
        }
    }

    public showMerchantEditProductSideBar: boolean = false;
    @Input()
    set _showMerchantEditProductSideBar(value: boolean) {
        this.showMerchantEditProductSideBar = value;
    }

    @Input() public merchantStoreOnboardingComponent!: MerchantStoreOnboardingComponent;
    @Input() public merchantProductsComponent!: MerchantProductsComponent;
    @Input() public partnerMartLocationsInventoryGridComponent!: PartnerMartLocationsInventoryGridComponent;

    @Output() changedShowMerchantEditProductSideBarEmit = new EventEmitter<{ visible: boolean; productIsEdited: boolean }>();
    changedShowMerchantEditProductSideBar(increased: any, reloadProducts: boolean) {
        this.changedShowMerchantEditProductSideBarEmit.emit({ visible: increased, productIsEdited: reloadProducts });
    }

    constructor(private messageService: MessageService,
        private merchantService: MerchantService, private storeService: StoreService,
        public appData: AppDataService, private productService: ProductService) {
        this.product.ExcludePproductFromStores = [];
    }

    public menuTab = MenuTab;
    public activeMenuTab: MenuTab = MenuTab.ProductDetails;
    public menuItems: MenuItem[] = [
        {
            label: 'Product details',
            id: `${MenuTab.ProductDetails}`,
            command: (e: any) => this.handleMenuTabChange(+e.item.id)
        },
        {
            label: 'Pricing',
            id: `${MenuTab.Pricing}`,
            command: (e: any) => this.handleMenuTabChange(+e.item.id)
        },
        {
            label: 'UOM',
            id: `${MenuTab.UOM}`,
            command: (e: any) => this.handleMenuTabChange(+e.item.id)
        },
        {
            label: 'Availability',
            id: `${MenuTab.ProductAvailability}`,
            command: (e: any) => this.handleMenuTabChange(+e.item.id)
        },
        {
            label: 'Inventory',
            id: `${MenuTab.Inventory}`,
            command: (e: any) => this.handleMenuTabChange(+e.item.id)
        }
    ];

    public loading: boolean = false;

    public product: any = {};
    public tags: any[] = [];
    public stores: any[] = [];
    public searchStores: any[] = [];
    public foundTags: any[] = [];
    public selectTag: any;
    public allCategories: any[] = [];
    public categories: any[] = [];
    public selectedParentCategory: any = undefined;

    public uomCategory = UOMCategory.UOMCategoryList;
    public selectedUOMCategory!: string;
    public locationType = LocationType.LocationTypeList;

    public isBtnSaveDisabled: boolean = false;
    public timerCheckField: any;

    public infoForFields = InfoForFields;
    public showDialogInfo: boolean = false;
    public dialogInfoObj: any = {
        Header: null,
        Description: null
    };

    ngOnInit(): void { }

    public getUOM() {
        return UOMCategory.getUOM(this.selectedUOMCategory);
    }

    public handleMenuTabChange(tab: MenuTab) {
        this.activeMenuTab = tab;
    }

    public checkFieldForRequired() {
        clearTimeout(this.timerCheckField);

        this.timerCheckField = setTimeout(() => {
            if (!this.appData.authData.MerchantId || !this.product.Name || !this.product.CategoryId
                || !this.product.Items[0].SellingPrice || !this.product.Items[0].UnitId) {
                this.isBtnSaveDisabled = true;
            } else {
                this.isBtnSaveDisabled = false;
            }
        }, 1000);
    }

    // Метод для добавления нового tag поля
    public addTag() {
        if (!this.selectTag) {
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Cannot add new tag. Empty tag exists.' });
            return;
        }
        if (this.foundTags.includes(this.selectTag)) {
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'The selected tag is already selected' });
            return;
        }
        this.foundTags.push(this.selectTag);
        this.selectTag = null;
    }

    // Метод для удаления tag поля по индексу
    public deleteTag(index: number) {
        this.foundTags.splice(index, 1);
    }

    // Проверка на наличие пустого объекта
    public hasEmptyTag(): boolean {
        return this.selectTag;
    }

    public getProductForEdit(): Promise<any> {
        return new Promise((resolve, reject) => {
            const dto = {
                ProductId: this.productId
            };

            this.productService.getProductForEdit(dto, this.messageService)
                .then(data => {
                    if (!data) {
                        this.loading = false;
                        reject('Error. Data is empty');
                        return;
                    }

                    if (!data.Success) {
                        this.loading = false;
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                        reject(data.ErrorMessage);
                        return;
                    }
                    this.selectedUOMCategory = UOMCategory.findUOM(data.Items[0].UnitId);
                    this.product = data;
                    this.findCategory(this.product.CategoryParentId);
                    this.getStoresByMerchant();
                    this.getTags();
                    this.loading = false;
                    resolve('Success');
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    public updateProduct() {
        this.loading = true;

        if (!this.product.MerchantId || !this.product.Name || !this.product.CategoryId ||
            !this.product.Items[0].SellingPrice || !this.product.Items[0].UnitId) {
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Fill all required fields.' });
            this.loading = false;
            return;
        }

        const dto = {
            Id: this.product.Id,
            TemplateProductId: this.product.TemplateProductId,
            MerchantId: this.product.MerchantId,
            Name: this.product.Name,
            ImageUrl: this.product.ImageUrl,
            SKU: this.product && this.product.SKU ? this.product.SKU.toString() : '',
            Description: this.product.Description,
            CategoryId: this.product.CategoryId,
            Tags: this.foundTags.map((p: any) => p.Id),
            ExcludePproductFromStores: this.product.ExcludePproductFromStores.map((p: any) => p.Id),
            Items: [this.product.Items[0]]
        };

        this.productService.updateProduct(dto, this.messageService).then(data => {
            if (!data) {
                this.loading = false;
                return;
            }

            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.loading = false;
            this.changedShowMerchantEditProductSideBar(false, true);
            if (this.partnerMartLocationsInventoryGridComponent !== null) {
                this.partnerMartLocationsInventoryGridComponent.getProductsByStore(0);
            }
            if (this.merchantProductsComponent !== null) {
                this.merchantProductsComponent.getProductsByMerchant(0);
            }
        });
    }

    public handleImageClick(id: string): void {
        document.getElementById(id)?.click();
    }

    public handleImageChange(event: Event) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        // Chech max file size 2MB
        if (file.size > 2097152) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                // Base64 string
                this.product.ImageUrl = e.target.result.toString();
            }
        };

        reader.readAsDataURL(file);
    }

    private getAllCategories(): Promise<any> {
        return new Promise((resolve, reject) => {
            const dto = {
                ParentId: null,
                GetAll: true,
                MerchantId: null
            };
            this.productService.getCategories(dto, this.messageService)
                .then(data => {
                    if (!data) {
                        reject('Error. Data is empty');
                        return;
                    }

                    this.allCategories = data;
                    this.categories = data;
                    resolve('Success');
                }).catch(error => {
                    reject(error);
                });
        });
    }

    private getTags(): void {
        this.productService.getTags(null, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.tags = data.Items;
                this.product.Tags.forEach((p: any) => {
                    const foundTag = this.tags.find(s => s.Id === p);
                    if (foundTag !== null && foundTag !== undefined) {
                        this.foundTags.push(foundTag);
                    }
                });
            });
    }

    public handleParentCategoryChange(): void {
        this.checkFieldForRequired();
        this.getCategories();
    }

    public getStoresByMerchant() {
        const dto = {
            MerchantId: this.appData.authData.MerchantId
        };

        this.storeService.getStoresByMerchant(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.stores = data.Items;

                const foundStores: any[] = [];
                this.product.ExcludePproductFromStores.forEach((p: any) => {
                    // Находим объект с нужным Id
                    const foundStore = this.stores.find(s => s.Id === p);

                    // Если найден объект, то добавляем его в массив найденных объектов
                    if (foundStore) {
                        foundStores.push(foundStore);
                    }
                });
                this.product.ExcludePproductFromStores = foundStores;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public searchStoresByMerchant(event: any) {
        this.searchStores = this.stores.filter(option =>
            option.Name.toLowerCase().indexOf(event.query.toLowerCase()) !== -1 &&
            !this.product.ExcludePproductFromStores.some((p: any) => p.Name === option.Name));
    }

    private getCategories(): void {
        this.categories = [];
        for (const category of this.allCategories) {
            if (this.selectedParentCategory) {
                if (category.ParentId === this.selectedParentCategory.Id) {
                    this.categories.push(category);
                }
            }
        }

        if (this.categories.length === 0) {
            this.categories = this.allCategories;
        }
    }

    private findCategory(id: number) {
        const category = this.allCategories.find(f => f.Id === id);
        if (category) {
            this.selectedParentCategory = category;
        }
    }

    cancel() {
        this.changedShowMerchantEditProductSideBar(!this.showMerchantEditProductSideBar, false);
    }

    public clickStore(object: any) {
        console.log(object);
        const foundProduct = this.product.ExcludePproductFromStores.find((s: any) => s.Id === object.Id);
        if (!foundProduct) {
            this.product.ExcludePproductFromStores.push(object);
        }
    }
    // Метод для удаления store по индексу
    public deleteStore(index: number) {
        this.product.ExcludePproductFromStores.splice(index, 1);
    }

    public openDialogInfo(infoField: InfoForFields) {
        this.showDialogInfo = true;

        if (infoField === InfoForFields.DailyInventory) {
            this.dialogInfoObj.Header = 'Daily Inventory Level';
            this.dialogInfoObj.Description = `Each product requires its own inventory level so it can be displayed in your store. 
This quantity is used to adjust what products your store has available everyday.
For example, if you set the product inventory to ’10’ this means 10 items can be sold daily. Note: This quantity resets daily at midnight.`;
        }
        else if (infoField === InfoForFields.SendLowInventoryEmail) {
            this.dialogInfoObj.Header = 'Send low inventory email';
            this.dialogInfoObj.Description = `Once a product drops below a certain quantity, we can automatically send you an email to let you know.`;
        }
        else if (infoField === InfoForFields.Supplier) {
            this.dialogInfoObj.Header = 'Supplier';
            this.dialogInfoObj.Description = `By adding your supplier, we can group products from the same supplier that has low inventory, 
this will save you from receiving multiple emails about the same supplier.`;
        }
    }
}
